import React, { useState } from "react";
import "./App.css";
import { SERVER, allowed_size } from "./constants.js";

const App = () => {
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [selectedBackground, setSelectedBackground] = useState(null);
  const [processedImage, setProcessedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const backgrounds = [
    "#ffcccc",
    "#cceeff",
    "https://img.freepik.com/free-vector/blue-geometric-frame-vector_53876-162370.jpg",
    "https://img.freepik.com/free-vector/paper-style-luxury-golden-details-background_23-2148967390.jpg",
    "https://img.freepik.com/free-vector/simple-blue-gradient-background-vector-business_53876-174948.jpg",
  ];

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleBackgroundChange = (bg) => {
    setSelectedBackground(bg);
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    if (!image || !selectedBackground) {
      alert("Please upload an image and select a background.");
      return;
    }
    if (image.size > allowed_size) {
      alert("Please upload a small image under 1MB!");
      return;
    }

    const formData = new FormData();
    formData.append("image", image);
    formData.append("background", selectedBackground);

    try {
      const response = await fetch(`${SERVER}/upload`, {
        method: "POST",
        body: formData,
      });
      console.log("Response:", response);
      const data = await response.json();
      setProcessedImage(data.image); // Base64 image
    } catch (error) {
      console.error("Error changing background:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="Logo">
        <a href="https://ost.agency/" target="_blank">
          <img src="/logo.svg" alt="OpenSource Technologies" width="250" height=""></img>
        </a>
      </div>
      <h1>Image Background Changer</h1>
      <div className="upload-section-outer">
        <div className="upload-section-left">

            <h2>Upload your image and select a new background!</h2>

            <div className="upload-section">
              <input
                type="file"
                accept="image/*"
                id="upload"
                onChange={handleImageUpload}
                disabled={isLoading}
              />
              <label htmlFor="upload" className="upload-label">
                Choose an Image
              </label>
            </div>

            {previewUrl && (
              <img
                src={previewUrl}
                alt="Preview"
                className="upload-preview"
                width={"500px"}
              />
            )}

        </div>

        <div className="upload-section-right">
         <div>
            <h2>Select a Background:</h2>
            <div className="background-options">
              {backgrounds.map((bg, index) => (
                <div
                  key={index}
                  className={`background-option${selectedBackground === bg ? ' active' : ''}`}
                  style={{
                    background: bg.startsWith("http") ? `url(${bg})` : bg,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  onClick={() => handleBackgroundChange(bg)}
                />
              ))}
            </div>
          </div>

          <button
            onClick={handleSubmit}
            className="submit-button"
            disabled={isLoading}
          >
            {isLoading ? "Changing..." : "Change Background"}
          </button>

          {processedImage && (
            <div>
              <h2>Result:</h2>
              <img
                src={processedImage}
                alt="Result"
                className="result-image"
                width={"500px"}
              />
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export default App;
